import React from 'react';
import cnames from 'classnames';
import { Link } from 'gatsby';
import styles from './NavBar.module.scss';

class NavBar extends React.Component {
  render() {
    const items = [
      // { title: "Let Remi Speak", path: '/let-remi-speak/', highlight: true },
      { title: 'Program', path: '/program/' },
      { title: 'Speakers', path: '/speakers/' },
      { title: 'Tickets', path: '/tickets/' },
      { title: 'Info', path: '/info/' },
      { title: 'Highlights', path: '/highlights/' },
    ];

    const isActive = ({ isPartiallyCurrent }, { highlight }) => {
      return isPartiallyCurrent ? {className: cnames(styles.active, styles.link, { [styles.highlight]: highlight})} : null
    }

    return (
      <nav className={cnames(styles.menu, this.props.className)}>
        <ul>
          <li><Link to="/"><img className={styles.logo} src="/assets/logo.png" /></Link></li>
          {items.map(item =>
            <li key={item.path}>
              <Link to={item.path}
                className={cnames(styles.link, { [styles.highlight]: item.highlight })}
                getProps={(args) => isActive(args, item)}
              >
                {item.title}
              </Link>
            </li>
          )}
        </ul>
      </nav>
    );
  }

}

export default NavBar;